import { apiCall } from "../../utils/servicesUtils"
import { appendBrandGuidelinesParams } from "./brandApi"

const BASE_URL = process.env.REACT_APP_BACKEND_URL

export interface GenerateParams {
  operation: string
  project_id: string
  thread_id: string
  picture_id?: string
  video_id?: string
  prompt?: string
  prompts?: string[]
  model?: string
  edit_hotspot_x?: number
  edit_hotspot_y?: number
  edit_region_json?: string
  extending_configs_json?: string
  translation_rows_json?: string
  output_ratios?: string[]
  output_languages?: string[]
  input_language?: string
  formats?: string
  label?: string
  factor?: string
  combos?: string[]
  top_margin_pct?: number
  left_margin_pct?: number
  right_margin_pct?: number
  bottom_margin_pct?: number
  use_brand_guidelines?: boolean
  excluded_asset_ids?: string[]
  additionnal_images?: Blob[]
  additionnal_images_categories?: string[]
  end_frame?: Blob
  music_file?: Blob
}

export const apiPostGenerate = (params: GenerateParams): Promise<{ job_id: string }> => {
  const formData = new FormData()

  formData.append('operation', params.operation)
  formData.append('project_id', params.project_id)
  formData.append('thread_id', params.thread_id)

  const simpleFields: (keyof GenerateParams)[] = [
    'picture_id', 'video_id', 'prompt', 'model',
    'edit_hotspot_x', 'edit_hotspot_y',
    'edit_region_json', 'extending_configs_json', 'translation_rows_json',
    'input_language', 'formats', 'label', 'factor',
    'top_margin_pct', 'left_margin_pct', 'right_margin_pct', 'bottom_margin_pct',
  ]
  for (const key of simpleFields) {
    const val = params[key]
    if (val !== undefined && val !== null) {
      formData.append(key, String(val))
    }
  }

  appendBrandGuidelinesParams(formData, params.use_brand_guidelines, params.excluded_asset_ids)

  if (params.prompts) {
    formData.append('prompts_json', JSON.stringify(params.prompts))
  }
  if (params.output_ratios) {
    for (const r of params.output_ratios) {
      formData.append('output_ratios', r)
    }
  }
  if (params.output_languages) {
    for (const l of params.output_languages) {
      formData.append('output_languages', l)
    }
  }
  if (params.combos) {
    for (const c of params.combos) {
      formData.append('combos', c)
    }
  }

  if (params.additionnal_images) {
    for (const img of params.additionnal_images) {
      formData.append('additionnal_images', img)
    }
  }
  if (params.additionnal_images_categories) {
    for (const cat of params.additionnal_images_categories) {
      formData.append('additionnal_images_categories', cat)
    }
  }
  if (params.end_frame) {
    formData.append('end_frame', params.end_frame)
  }
  if (params.music_file) {
    formData.append('music_file', params.music_file)
  }

  return apiCall(`${BASE_URL}/api/v2/generate`, 'POST', formData, true)
}

type LockedModelParams = Omit<GenerateParams, 'operation' | 'model' | 'project_id' | 'thread_id' | 'picture_id'>
  & {
    project_id: string
    thread_id: string
    picture_id: string
  }

export const apiPostRegionalEdit = (
  params: LockedModelParams & { edit_region_json: string },
): Promise<{ job_id: string }> => {
  return apiPostGenerate({
    ...params,
    operation: 'inpaint',
    model: 'google',
  })
}

export const apiPostReformat = (
  params: LockedModelParams,
): Promise<{ job_id: string }> => {
  return apiPostGenerate({
    ...params,
    operation: 'reformat_margins',
    model: 'google',
  })
}

export const apiPostCancelGeneration = (
  jobId: string,
  projectId: string
): Promise<{ status: string }> => {
  return apiCall(
    `${BASE_URL}/api/v2/generate/${jobId}/cancel`,
    'POST',
    JSON.stringify({ project_id: projectId }),
  )
}
